import classNames from 'classnames';
import A from 'components/Link/Link';
import React from 'react';

type ChipsItemProps = {
  title: string;
  clickableLink: any;
  isClickable: boolean;
  onClick: (e) => void;
};

export const ChipsItem = (props: ChipsItemProps) => {
  const { title, isClickable, clickableLink, onClick } = props;

  return (
    <div className={classNames('chips-item')}>
      <span className={`chips-item__content ${isClickable ? 'clickable' : ''}`}>
        <span className={`chips-item__name ${isClickable ? 'clickable-name' : 'not-clickable-name'}`}>
          {isClickable && clickableLink ? (
            <A href={clickableLink.href} as={clickableLink.as} onClick={onClick}>
              {title}
            </A>
          ) : (
            title
          )}
        </span>
      </span>
    </div>
  );
};
